import {useContext, useEffect} from 'react';
import {GuardedRouterActionType} from '../../components/router/guarded-router-context.model';
import {GuardedRouterContext} from '../../components/router/GuardedRouterContext';
import {UserData} from '../../security-context.model';
import {LOGIN_SIGNAL_KEY} from '../../constants/session';

// Evicts this tab when another tab logs in, enforcing a single-tab session.
export function useSingleTabSession(
  setUserData: (value?: UserData) => void,
  setIsLogged: (value: boolean) => void
): void {
  const {dispatchAction} = useContext(GuardedRouterContext);

  useEffect(() => {
    // storage events fire only in other tabs, so the tab that logged in is unaffected.
    const handleLoginElsewhere = (event: StorageEvent): void => {
      if (event.key === LOGIN_SIGNAL_KEY && event.newValue) {
        setUserData(undefined);
        setIsLogged(false);
        dispatchAction({type: GuardedRouterActionType.UNLOCK_ROUTE_CHANGE});
      }
    };

    window.addEventListener('storage', handleLoginElsewhere);
    return (): void => window.removeEventListener('storage', handleLoginElsewhere);
  }, []);
}